function objectToQueryString(obj: any, page?: number, pageSize?: number) {
  const parts: string[] = [];
  // debugger;
  if (obj) {
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (Array.isArray(value)) {
        if (key === "skills") {
          const keyValuePairs = value
            .map((item) => `${key}[]=${item}`)
            .join("&");
          parts.push(keyValuePairs);
        } else {
          const keyValuePairs = value
            .map((item) => `${key}[]=${item.id}`)
            .join("&");
          parts.push(keyValuePairs);
        }
      } else {
        parts.push(`${key}=${value}`);
      }
    });

    return `?${parts.join("&")}&page=${page}&per=${pageSize}`;
  }
  return `?page=${page}&per=${pageSize}`;
}

export default objectToQueryString;
